import { useThemeStore } from '../../stores/themeStore.js'

/** Logo Jean Louis : blanc sur le thème sombre, foncé sur le thème clair. */
export default function BrandLogo({ className, alt = 'Jean Louis' }) {
  const theme = useThemeStore((state) => state.theme)
  const src = theme === 'light' ? '/brand/jean-louis-noir.svg' : '/brand/jean-louis-blanc.svg'
  return <img src={src} alt={alt} className={className} />
}
